export const APP_ROUTES = {
    rallies: '/rallies',
    becomeCreator: '/become-creator',
    faq: '/faq',
    rallyPreview: '/rallies/:id',
    rallyRegistration: '/rallies/:id/registration',
    rallyGamePlay: '/rallies/:id/gameplay/:task',
    rallyGameResult: '/rallies/:id/game-result',
    adminLogin: '/admin/login',
    adminForgotPassword: '/admin/forgot-password',
    adminResetPassword: '/admin/reset-password',
    adminManageRallies: '/admin/rallies',
    adminFaq: '/admin/faq',
    adminCreateRally: '/admin/rallies/create-rally',
    adminEditRally: '/admin/rallies/:id',
    adminManageTasks: '/admin/rallies/:id/tasks',
    adminCreateTask: '/admin/rallies/:id/tasks/create-task',
    adminEditTask: '/admin/rallies/:id/tasks/:task',
    adminRallySessions: '/admin/rallies/:id/results',
    adminRallySessionResults: '/admin/rallies/:id/results/:session',
    adminRallyPreview: '/admin/rallies/:id/rally-preview/:task',
    adminTaskPreview: '/admin/rallies/:id/task-preview/:task',
    adminPublishedRally: '/admin/rallies/:id/published',
    institutions: '/admin/institutions',
    createInstitution: '/admin/institutions/create-institution',
    editInstitution: '/admin/institutions/:id',
    editors: '/admin/editors',
    createEditor: '/admin/editors/create-editor',
    editEditor: '/admin/editors/:id',
    editorsPerInstitution: '/admin/institution/:id/editors',
    superAdminCreateEditor: '/admin/institution/:id/editors/create-editor',
    superAdminEditEditor: '/admin/institution/:id/editors/:editor',
    manageInstitution: '/admin/institution',
    institutionVerification: '/admin/institution-verification',
};
